// extracted by mini-css-extract-plugin
module.exports =  {"item":"Q6UODcxfM1qvmslF4Uzo","noFlightsContainer":"tC3hKsFtOFt54k9xZ0ik"};